import React, { useState } from 'react';

import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import LoadingScreen from 'src/components/LoadingScreen';

import { useData } from 'src/contexts/data';
import { ModelOfOrderService } from 'src/database';
import { useFinishOrderServiceListController } from 'src/controllers/OrderService/ListFinishOrderServiceControle';
import FinishOrderServiceCard from 'src/components/Cards/ServiceOrderCard/FinishOrderServiceCard';

const FinishOrderServiceList: React.FC = () => {
  const { getFinishOrderServiceListController, handleFinishOrderServiceListController } = useFinishOrderServiceListController();
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const { handleSelectedDemand } = useData();

  if (getFinishOrderServiceListController.loading) {
    return <LoadingScreen />
  };

  const handleFilter = (OrderServiceList: ModelOfOrderService[]) => {
    const OrderService = OrderServiceList.filter((orderService) => orderService.DESCRICAO_DEMANDA?.toUpperCase().includes(globalFilter?.toUpperCase()))
    return OrderService
  }

  return (
    <div className="p-card p-p-4 datatable-container">
      <Toast ref={getFinishOrderServiceListController.toast} />
      <div className="service-header p-grid">
        <h5 className="p-m-0">Ordem de serviços finalizadas</h5>
        <span className="p-input-icon-left p-search-bar">
          <i className="pi pi-search" />
          <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Filtrar por Descricao" />
        </span>
      </div>

      {getFinishOrderServiceListController.finishOrderServiceData.length ?
        handleFilter(getFinishOrderServiceListController.finishOrderServiceData).map((OrderService) => {
          return (
            <FinishOrderServiceCard key={OrderService.ID}
              orderService={OrderService}
              handleClick={() => handleSelectedDemand(
                handleFinishOrderServiceListController.handleClickOrderService(OrderService)
              )}
            />
          )
        })
        :
        <h5>Nenhum resultado encontrado!</h5>
      }
    </div>
  )
}

export default FinishOrderServiceList;
